var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "#E2F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5167_37174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9854 20.9544H22.399C23.9991 19.7078 25.9851 19.0049 28.0515 19.0049C32.516 19.0049 36.2987 22.1484 37.0459 26.4795L39.0508 26.1437C38.1367 20.8453 33.5109 17 28.0515 17C25.4406 17 22.9346 17.9179 20.9466 19.5387V17.9971H18.9131V22.9596H23.9857V20.9544H23.9854ZM32.1264 34.9746H33.7926C32.1778 36.2647 30.1548 36.9951 28.0512 36.9951C23.5836 36.9951 19.801 33.8491 19.0557 29.5142L17.0508 29.8489C17.9618 35.1517 22.5881 39 28.0512 39C30.6643 39 33.1759 38.0797 35.1655 36.4547V37.9324H37.1991V32.9696H32.1264V34.9746Z",
    fill: "#34656D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7899 33L25.0508 28.3782V27.7619H25.3696C25.8817 27.7619 26.3117 27.7152 26.6595 27.6218C27.017 27.5285 27.2972 27.3744 27.5001 27.1597C27.703 26.9449 27.8237 26.6508 27.8624 26.2773H25.0508V25.381H27.8479C27.7802 25.0355 27.645 24.7554 27.4421 24.5406C27.2392 24.3165 26.9638 24.1531 26.616 24.0504C26.2778 23.9477 25.8624 23.8964 25.3696 23.8964H25.0508V23H31.0508V23.8964H28.3117C28.5339 24.0738 28.7174 24.2838 28.8624 24.5266C29.0073 24.7694 29.0991 25.0542 29.1377 25.381H31.0508V26.2773H29.1667C29.0991 26.9589 28.8286 27.4911 28.3551 27.874C27.8914 28.2474 27.273 28.4855 26.5001 28.5882L29.2682 33H27.7899Z",
    fill: "#34656D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5167_37174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    fill: "white",
    transform: "translate(12.0781 11.7246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlock);
export default __webpack_public_path__ + "static/media/Payment_Block.3c65ae539df6616bdefc76715fc57496.svg";
export { ForwardRef as ReactComponent };